import { render, staticRenderFns } from "./Biblioteca.vue?vue&type=template&id=619e56e7"
import script from "./Biblioteca.vue?vue&type=script&lang=js"
export * from "./Biblioteca.vue?vue&type=script&lang=js"
import style0 from "./Biblioteca.vue?vue&type=style&index=0&id=619e56e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QDialog,QCardSection,QSpace,QBtn,QSeparator});qInstall(component, 'directives', {ClosePopup});
